$(document).ready(function() {
  $('.btn-share-link').on('click', function(e) {
    e.preventDefault();
    var copyText = $(this).attr('data-copy');
    navigator.clipboard.writeText(copyText);

    // Alert the copied text
    var link = $(this);
    link.addClass('copied');
    setTimeout(function() {
    link.removeClass('copied');
    }, 1000);
  });
});